/**
 * Here goes the global constants for the appli page
 */

export const GOOGLE = 'google';
export const APPLE = 'apple';
export const GOOGLE_LINK = '';
export const APPLE_LINK = '';



// WEBPACK FOOTER //
// ./src/constants/mobile.js